import type { RouteParamValue } from 'vue-router'

/**
 * One path param as the string it is, for a redirect building a path out of what
 * it matched.
 *
 * An absent param and an empty repeat both come back as `''`, which builds a path that
 * matches nothing and lands on /404 — so do not use it where a missing param has to
 * be handled.
 */
export const routeParam = (
  value: RouteParamValue | RouteParamValue[] | undefined
): string => (Array.isArray(value) ? (value[0] ?? '') : (value ?? ''))
